import React, { useState, useEffect } from 'react';

function ContactForm({ question, value = [], onChange }) {
  const [contacts, setContacts] = useState(value || []);

  // Update local state when value prop changes (new question)
  useEffect(() => {
    setContacts(value || []);
  }, [value, question.id]);

  const addContact = () => {
    const newContact = {};
    question.fields.forEach(field => {
      newContact[field] = '';
    });
    const updatedContacts = [...contacts, newContact];
    setContacts(updatedContacts);
    onChange(updatedContacts);
  };

  const updateContact = (index, field, newValue) => {
    const updatedContacts = [...contacts];
    updatedContacts[index][field] = newValue;
    setContacts(updatedContacts);
    onChange(updatedContacts);
  };

  const removeContact = (index) => {
    const updatedContacts = contacts.filter((_, i) => i !== index);
    setContacts(updatedContacts);
    onChange(updatedContacts);
  };

  const moveContact = (index, direction) => {
    if ((direction === 'up' && index === 0) || (direction === 'down' && index === contacts.length - 1)) return;
    
    const updatedContacts = [...contacts];
    const targetIndex = direction === 'up' ? index - 1 : index + 1;
    [updatedContacts[index], updatedContacts[targetIndex]] = [updatedContacts[targetIndex], updatedContacts[index]];
    
    setContacts(updatedContacts);
    onChange(updatedContacts);
  };

  const getFieldLabel = (field) => {
    const labels = {
      priority: 'Priority',
      name: 'Name',
      relationship: 'Relationship',
      phone: 'Phone',
      email: 'Email'
    };
    return labels[field] || field;
  };

  const getFieldType = (field) => {
    if (field === 'email') return 'email';
    if (field === 'phone') return 'tel';
    return 'text';
  };

  return (
    <div className="contact-form">
      <h3>{question.text}</h3>
      {question.description && <p className="question-description">{question.description}</p>}
      
      <div className="contacts-list">
        {contacts.map((contact, index) => (
          <div key={index} className="contact-item">
            <div className="contact-header">
              <span className="contact-number">#{index + 1}</span>
              <div className="contact-controls">
                {question.fields.includes('priority') && (
                  <>
                    <button 
                      type="button" 
                      onClick={() => moveContact(index, 'up')}
                      disabled={index === 0}
                      className="move-button"
                      aria-label="Move up"
                    >
                      ↑
                    </button>
                    <button 
                      type="button" 
                      onClick={() => moveContact(index, 'down')}
                      disabled={index === contacts.length - 1}
                      className="move-button"
                      aria-label="Move down"
                    >
                      ↓
                    </button>
                  </>
                )}
                <button 
                  type="button" 
                  onClick={() => removeContact(index)}
                  className="remove-button"
                  aria-label="Remove contact"
                >
                  ×
                </button>
              </div>
            </div>
            <div className="contact-fields">
              {question.fields.map(field => (
                field !== 'priority' && (
                  <div key={field} className="contact-field">
                    <label>{getFieldLabel(field)}:</label>
                    <input
                      type={getFieldType(field)}
                      value={contact[field] || ''}
                      onChange={(e) => updateContact(index, field, e.target.value)}
                      placeholder={`Enter ${field}`}
                      onClick={(e) => e.stopPropagation()}
                      onFocus={(e) => e.stopPropagation()}
                    />
                  </div>
                )
              ))}
            </div>
          </div>
        ))}
      </div>
      
      <button type="button" onClick={addContact} className="add-contact-button">
        + Add Contact
      </button>
    </div>
  );
}

export default ContactForm;